import React, { useContext, useState } from 'react';
import { notification, Typography } from 'antd';
import {
  UserOutlined,
  LockOutlined,
  BarChartOutlined,
  KeyOutlined,
} from '@ant-design/icons';
import { AppContext } from '../../hooks/AppProvider';
import { api } from '../../api';
import { ProfileSection } from './ProfileSection';
import { QuotaSection } from './QuotaSection';
import { ApiKeySection } from './ApiKeySection';
import { SecuritySection } from './SecuritySection';
import { AccountWrapper, StyledTabs } from './styles';

const { Title } = Typography;

interface PasswordForm {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const Account: React.FC = () => {
  const { user } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [notifApi, contextHolder] = notification.useNotification();

  const showNotification = (
    type: 'success' | 'error',
    message: string,
    description: string,
  ) => {
    notifApi[type]({
      message,
      description,
      placement: 'topRight',
      duration: 3,
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePasswordChange = async (values: PasswordForm, form: any) => {
    setLoading(true);
    try {
      await api.auth.changePassword(
        user!.email,
        values.currentPassword,
        values.newPassword,
      );
      showNotification(
        'success',
        'Password Updated',
        'Your password has been successfully changed',
      );
      form.resetFields();
    } catch (error) {
      console.error(error);
      showNotification('error', 'Update Failed', 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined style={{ marginRight: 4 }} />
          Profile Information
        </span>
      ),
      children: <ProfileSection user={user!} />,
    },
    {
      key: '2',
      label: (
        <span>
          <BarChartOutlined style={{ marginRight: 4 }} />
          Usage Quota
        </span>
      ),
      children: <QuotaSection />,
    },
    {
      key: '3',
      label: (
        <span>
          <KeyOutlined style={{ marginRight: 4 }} />
          API Keys
        </span>
      ),
      children: <ApiKeySection />,
    },
    {
      key: '4',
      label: (
        <span>
          <LockOutlined style={{ marginRight: 4 }} />
          Security
        </span>
      ),
      children: (
        <SecuritySection loading={loading} onSubmit={handlePasswordChange} />
      ),
    },
  ];

  if (!user) {
    return null;
  }

  return (
    <AccountWrapper>
      {contextHolder}
      <Title level={2}>Account Settings</Title>
      <StyledTabs defaultActiveKey="1" items={items} />
    </AccountWrapper>
  );
};
